<template>
  <div>
    <breadcrumbs :back="[{text:'Fermenters',to:{name:'EquipmentFermenters'}}]" :home="name"/>

    <purtrak-table name="fermentertransactions" objectType="transactions" :defaultColumns="defaultColumns" :headers="headers" ref="table" show-select
                   :listEndPoint="getListData" fields="" totalField="" v-model="selected"
                   :listFilters="listFilters" :sortBy.sync="sortBy"
                   @dblclick="transaction => viewTransaction(transaction)"
                   :title="name"
                   :print-info="{pageSize:'landscape',
                                 subTitle:[filters.from?dateDisplay:'',filters.activityType!=''?activityTypes.find(a=>a.value==filters.activityType).text:'']}"
                   :download-endpoint="exportListData">
      <template v-slot:filter>
        <filter-menu include-reset @reset="filters.siteId=null;filters.activityType='';filters.excise='All',filters.from=null;filters.to=null">
          <v-list-item>
            <date-range :from.sync="filters.from" :to.sync="filters.to" v-model="dateDisplay" option="All" allow-all/>
          </v-list-item>
          <v-list-item>
            <v-autocomplete label="Activity" dense outlined :items="activityTypes" v-model="filters.activityType"/>
          </v-list-item>
        </filter-menu>
        <template v-if="!$vuetify.breakpoint.mobile">
          <v-chip v-show="filters.from!=null" close small class="ml-1" @click:close="filters.from=null;filters.to=null">{{dateDisplay}}</v-chip>
          <v-chip v-show="filters.activityType!=''" close small class="ml-1" @click:close="filters.activityType=''">{{activityTypes.find(a=>a.value==filters.activityType).text}}</v-chip>
        </template>
      </template>

      <template v-slot:footer v-if="selected.length">
        <v-icon style="position: absolute" class="mt-3 ml-3">mdi-arrow-up-left</v-icon>
        <v-btn color="primary" outlined x-small style="position: absolute" class="mt-5 ml-10" @click="deleteMultiple=true;showDelete=true">Batch delete</v-btn>
      </template>
      <template v-slot:item.date="{value}">
        {{value | formatDateTime}}
      </template>
      <template v-slot:item.description="{item,printing}">
        {{item.description}}
        <div v-if="printing" class="text-caption">{{item.comments}}</div>
      </template>
      <template v-slot:item.volume="{value,printing}">
        <template v-if="printing">{{value | number(0)}} litres</template>
        <span v-else :class="{'red--text':value<0}">
          {{value | number(0)}} litres
        </span>
      </template>
      <template v-slot:item.volumeBalance="{value}">
        {{value | number(0)}} litres
      </template>
      <template v-slot:item.valueBalance="{value}">
        {{value | currency}}
      </template>
      <template v-slot:item.lot="{item,printing}">
        <template v-if="printing">{{item.lot}}</template>
        <v-hover v-else v-slot="{hover}">
          <a @click.stop="$router.push({name:'ReportsView',params:{back:[{text:'Fermenters',to:{name:'EquipmentFermenters'}},{text:name,to:{name:'EquipmentFermentersTransactions',params:{fermenterId}}}]},query:{to:'reports/inventory/ReportsLot',id:item.refId,lot:item.lot,forward:0}})"
             :class="{'text-decoration-underline':hover}">{{item.lot}}</a>
        </v-hover>
      </template>
      <template v-slot:item.value="{value}">
        {{value | currency}}
      </template>
      <template v-slot:item.action="{item}">
        <v-menu :nudge-width="150" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn small v-on="on" v-if="$vuetify.breakpoint.mobile" outlined>Transaction operations</v-btn>
            <v-btn small icon v-on="on" v-else><v-icon small>mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="view(item)"><v-list-item-title>Details</v-list-item-title></v-list-item>
            <v-list-item :to="{name:'ReportsView',params:{back:[{text:'Fermenters',to:{name:'EquipmentFermenters'}},{text:name,to:{name:'EquipmentFermentersTransactions',params:{fermenterId}}}]},query:{to:'reports/inventory/ReportsLot',id:item.refId,lot:item.lot,forward:0}}"><v-list-item-title>Trace lot</v-list-item-title></v-list-item>
            <v-list-item v-if="audit" :to="{name:'Audit',query:{entityId:item.refId}}"><v-list-item-title>Audit history</v-list-item-title></v-list-item>
            <template v-if="!readOnly">
              <v-divider/>
              <v-list-item @click="transaction=item;deleteMultiple=false;showDelete=true"><v-list-item-title>Delete transaction</v-list-item-title></v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:body.append="{headers,printing}" v-if="!$vuetify.breakpoint.mobile">
        <tr :class="darkMode ? 'total-row-dark' : 'total-row'">
          <template v-for="header of headers">
            <td class="text-right" v-if="header.value==='volume'">
              {{totals.totalVolume | number(0)}} litres
            </td>
            <td class="text-right" v-else-if="header.value==='value' && values">
              {{totals.totalValue | currency}}
            </td>
            <td v-else-if="!printing || header.print === undefined || header.print"/>
          </template>
        </tr>
      </template>
    </purtrak-table>

    <delete-object v-model="showDelete" :name="deleteMultiple?'ALL selected transactions':'this transaction'" @delete="performDelete(transaction.refId, 'refId')"/>
  </div>
</template>

<script>
import performDelete from '@/mixins/performDelete'

export default {
  name: 'EquipmentFermentersTransactions',
  mixins: [performDelete],
  props: {
    fermenterId: {type:String, required:true}
  },
  data() {
    return {
      name: '',
      filters: {
        from: null,
        to: null,
        activityType: ''
      },
      sortBy: '',
      dateDisplay: '',
      totals: {totalVolume:0, totalValue:0},
      activityTypes: [{text:'All',value:''},{divider:true},
                      {text:'Initial',value:'FermenterTransactionInitial'},
                      {text:'Reduce inventory',value:'FermenterTransactionReduceInventory'},
                      {text:'Transfer',value:'FermenterTransactionInternalTransfer'},
                      {text:'Mash',value:'Mash'},
                      {text:'Distillation',value:'Distillation'}
                      ],
      transaction: {},
      showDelete: false,
      deleteMultiple: false,
      defaultColumns: [{ value: 'date', visible:true},
                       { value: 'description', visible:true},
                       { value: 'comments', visible:false},
                       { value: 'volume', visible:true},
                       { value: 'lot', visible:false},
                       { value: 'value', visible:false},
                       { value: 'valueBalance', visible:false},
                       { value: 'volumeBalance', visible:false}],
      headers: [{ text: 'DATE', value: 'date', width:'15%',sortable:true},
                { text: 'ACTIVITY', value: 'description', width:'35%',sortable:false},
                { text: 'COMMENTS', value: 'comments', width:'35%',sortable:false},
                { text: 'VOLUME', value: 'volume', width:'20%',sortable:true,align:'right'},
                { text: 'LOT', value: 'lot', width:'10%',sortable:true},
                { text: 'VALUE', value: 'value', width:'20%',sortable:true,align:'right', omit:() => !this.values},
                { text: 'VALUE BAL', value: 'valueBalance', width:'20%',sortable:false,align:'right', omit:() => !this.values || !this.showBalances},
                { text: 'VOLUME BAL', value: 'volumeBalance', width:'20%',sortable:false,align:'right', omit:() => !this.showBalances}]
    }
  },
  computed: {
    showBalances() {
      return this.filters.activityType === '' &&
             (this.sortBy === 'date' || this.sortBy === '');
    },
    company() {
      return this.$store.getters.company;
    },
    values() {
      return this.company.permissions.includes('values');
    },
    readOnly() {
      return !this.company.permissions.includes('production.write');
    },
    audit() {
      return this.company.allowAudit && this.company.permissions.includes('audit');
    },
    listFilters() {
      const filters = [];
      if (this.filters.from)
        filters.push({field:'date', comparator:'ge', value:`${this.filters.from} 00:00:00`});
      if (this.filters.to)
        filters.push({field:'date', comparator:'le', value:`${this.filters.to} 23:59:59`});
      if (this.filters.activityType !== '')
        filters.push({field:'refType', comparator:'eq', value:this.filters.activityType});
      return filters;
    }
  },
  methods: {
    async getListData(after, cursor, pageSize, filters, parameters, options) {
      const results = await this.$apiCall(`query EquipmentFermentersTransactions($id:ID!, $after: String, $first:Int, $before: String, $last: Int, $filters:[FilterInput], $sortKey: String, $reverse: Boolean, $parameters: [ParameterInput]) {
                                             fermenter(id:$id) {
                                                name
                                                transactions2(first:$first, after:$after, last:$last, before:$before, filters:$filters, sortKey:$sortKey, reverse:$reverse, parameters:$parameters) {
                                                  totalCount
                                                  totalVolume, totalValue
                                                  pageInfo {
                                                    hasPreviousPage
                                                    hasNextPage
                                                    startCursor
                                                    endCursor
                                                  }
                                                  edges {
                                                    cursor
                                                    node {
                                                      id,date,refType,refId,description,comments,volume,value,lot,volumeBalance,valueBalance
                                                    }
                                                  }
                                                }
                                              }
                                            }`,
                                           {id:this.fermenterId,
                                            after:after?cursor:null, first:after?pageSize:null,
                                            before:!after?cursor:null, last:!after?pageSize:null,
                                            filters, parameters,
                                            sortKey:options.sortBy[0], reverse:options.sortDesc[0]});

      const fermenter = results.data.fermenter;
      this.name = `${fermenter.name}: Transactions`;
      const transactions = fermenter.transactions2;
      Object.assign(this.totals, {totalVolume:transactions.totalVolume, totalValue:transactions.totalValue});
      return transactions;
    },

    async exportListData(filters, parameters, options) {
      const results = await this.$apiCall(`query EquipmentFermentersTransactions($id:ID!, $filters:[FilterInput], $sortKey: String, $reverse: Boolean, $parameters: [ParameterInput]) {
                                              fermenter(id:$id) {
                                                transactionsExportCSV(filters:$filters, sortKey:$sortKey, reverse:$reverse, parameters:$parameters)
                                              }
                                            }`,
                                          {id:this.fermenterId,
                                          filters, parameters,
                                           sortKey:options.sortBy[0], reverse:options.sortDesc[0]});
      if (!results.error)
        return results.data.fermenter.transactionsExportCSV;
    },
    viewTransaction(item) {
      switch (item.refType) {
        case 'FermenterTransactionReduceInventory':
          this.$router.push({name:'EquipmentFermentersReduceInventory',params:{transactionId:item.refId}})
          break;
        case 'FermenterTransactionTransfer':
          this.$router.push({name:'EquipmentFermentersTransferToFermenter',params:{transactionId:item.refId}})
          break;
        case 'Mash':
          this.$router.push({name:'ProductionMashingEdit',params:{mashId:item.refId}})
          break;
        case 'Distillation':
          this.$router.push({name:'ProductionDistillingEdit',params:{distillationId:item.refId}})
          break;
        default:
          this.$store.commit('setError', {message:'No further information available', type:'Info'})
          break;
      }
    }
  }
}
</script>